<div class="row no-gutters">
    <div class="col-md-12 col-lg-6">
        <div class="row no-gutters">
            <div class="col-sm-10">

                <div class="row">
                    <div class="col-sm-12">
                        <mat-form-field class="full-width mt-3">
                            <mat-label>{{ user.trans.qualifications | translate }}</mat-label>
                            <textarea id="{{idPrefix}}{{user.trans.qualifications}}"
                                      matInput
                                      rows="6"
                                      [(ngModel)]="user.qualifications">
                                </textarea>
                        </mat-form-field>
                    </div>
                </div>

            </div>
            <div class="col-sm-2">
                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
            </div>
        </div>
    </div>
</div>

<div class="row no-gutters mt-4">
    <div class="col-md-12 col-lg-6">
        <div class="row no-gutters">
            <div class="col-sm-10">
                <div class="smp-title-thin-border">{{ 'user_management.title.signature' | translate }} </div>

                <div class="row no-gutters">
                    <div class="col-sm-12 mt-4">
                        <smp-dropzone class="full-width"
                                      [idPrefix]="(idPrefix + 'client_user.dropzone_signature.')"
                                      [label]="'common.btn.browse' | translate"
                                      [acceptedFiles]="signatureAndStampFileTypes"
                                      [multi]="false"
                                      (filesSelected)="onSignatureFilesSelected($event)"
                                      [hasContent]="!!signature">
                            <thumb-nail [idPrefix]="(idPrefix + 'client_user.signature.')"
                                        [file]="signature"
                                        [disabledOptions]="disabledThumbnailOptions"
                                        (delete)="deleteSignature($event)">
                            </thumb-nail>
                        </smp-dropzone>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">

            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6">
        <div class="row no-gutters">
            <div class="col-sm-10">
                <div class="smp-title-thin-border">{{ 'user_management.title.stamp' | translate }} </div>

                <div class="row no-gutters">
                    <div class="col-sm-12 mt-4">
                        <smp-dropzone class="full-width"
                                      [idPrefix]="(idPrefix + 'client_user.dropzone_stamp.')"
                                      [label]="'common.btn.browse' | translate"
                                      [acceptedFiles]="signatureAndStampFileTypes"
                                      [multi]="false"
                                      (filesSelected)="onStampFilesSelected($event)"
                                      [hasContent]="!!stamp">
                            <thumb-nail [idPrefix]="(idPrefix + 'client_user.stamp.')"
                                        [file]="stamp"
                                        [disabledOptions]="disabledThumbnailOptions"
                                        (delete)="deleteStamp($event)">
                            </thumb-nail>
                        </smp-dropzone>
                    </div>
                </div>

            </div>
            <div class="col-sm-2">

            </div>
        </div>
    </div>
</div>
